import Vue from 'vue'
import VueRouter from 'vue-router'
import ta from './ta'
import admin from './admin'

Vue.use(VueRouter)
let r = [];

r.push({
  path: '/',
  name: 'home',
  component: () => import('@/views/Home.vue'),
  meta: {
    resource: 'RNONE',
    action: 'read',
    pageTitle: 'Home',
    breadcrumb: [
      {
        text: 'Home',
        active: true,
      },
    ],
  },
})

admin.forEach(i => {
  r.push(i)
})

ta.forEach(i => {
  r.push(i)
})

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: r
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
